import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { AllocationService } from "@services/allocation.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "allocations",
	styleUrls: ["allocations.css"],
	templateUrl: "allocations.html"
})
export class AllocationsAdminComponent {
	canExportGrid = false;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Allocation"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any = [];
	title: string;

	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: AllocationService, private protectedGridService: ProtectedGridService) {
		this.title = "Allocations";
		this.getItems();
		this.viewRow = this.viewRow.bind(this);
		this.checkGridExportPermissions();
	}

	attachWorkOrderIdsToGrid() {
		this.items.forEach((item: any) => {
			if (item.workOrders !== null && item.workOrders !== undefined && item.workOrders.length > 0) {
				const workOrderIds = item.workOrders.map((workOrder: any) => workOrder.workOrderId);
				item.workOrderIds = workOrderIds.join(", ");
			}
		});
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Allocations")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getFullDetails()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
					this.attachWorkOrderIdsToGrid();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Allocations";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}